import Type from "@actionTypes";

/**
 * app reducer
 * @param {*} state
 * @param {*} action
 */
export const app = (
  state = {
    count: 0,
    token: "",
    user: "",
    userID: "",
    sourceTree: {},
    // permissionMap: {},
    permissionTree: {},
    responsibleTree:{},
    callType:''
  },
  action
) => {
  switch (action.type) {
    case Type.ADD_COUNT:
      return {
        ...state,
        count: state.count + 1,
      };
    case Type.SET_DICT:
      return {
        ...state,
        sourceTree: action.sourceTree.dictionary,
      };
    case Type.SET_MEMBER:
      return {
        ...state,
        memberList: {
          ...state.memberList,
          [action.path]: action.memberList,
        },
      };
    // case Type.SET_PERMMAP:
    //   return {
    //     ...state,
    //     permissionMap: action.permissionMap,
    //   };
    case Type.LOGIN_SUCCESS:
      return {
        ...state,
        token: action.token,
      };
    case Type.SET_PERM: {
      return {
        ...state,
        permissionTree: action.permissionTree,
      };
    };
    case Type.SET_RESPONSIBLE: {
      return {
        ...state,
        responsibleTree: action.responsibleTree,
      };
    }
    case Type.SET_USER: {
      return {
        ...state,
        user: action.info.username,
        username: action.info.username,
        exten: action.info.exten,
      };
    }
    case Type.USER_LOGOUT_SUCCESS:
      return {
        ...state,
        token: "",
        userID: "",
        exten: "",
        sourceTree: {},
        permissionMap: {},
        permissionTree: {},
        responsibleTree:{},
        spinning: false,
      };
    case Type.SET_CLOSED_REASON:
      return {
        ...state,
        closedReason: action.data,
      }

    case Type.SET_BASEURL:
      return {
          ...state,
          baseUrl: action.baseUrl
    };
    case Type.SET_CALLTYPE:
      return {
        ...state,
        callType:action.callType
      };
    default:
      return state;
  }
};
